import React, { useContext, useEffect, useState } from "react";
import TaskListToolbar from "../../components/task/TaskListToolbar";
import TaskListView from "../../components/task/TaskListView";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";
import { useLocation } from "react-router-dom";
import { fetchTasks } from "../../service/Task";

const TaskManageMain = () => {
  const [openTab, setOpenTab] = useState(2);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedtask, setselectedtask] = useState([]);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [workflowName, setWorkflowName] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
      const [pageSize, setPageSize] = useState(10);
      const [totalValue, setTotalValue] = useState(0);
  const [finishedStatus, setFinishedStatus] = useState("");
  const { theme, langMode ,setPriority ,setActive ,active, priority,  selectedOrgId,workflowId, setTaskData,   setTotalPageSize, totalPageSize} = useContext(AppContext);
  const handleFilterChange = (filterType, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [filterType]: value }));
    setCurrentPage(0);
  };
  const location = useLocation()
  useEffect(() => {
    const getFromDate = sessionStorage.getItem("from_Date");
    setFromDate(getFromDate)

    const getToDate = sessionStorage.getItem("to_Date");
    setToDate(getToDate)
  }, [])
   useEffect (() =>{
      if(location.pathname=== '/task-manage'){
        // setPriority('Priority')
        // setActive('Status')
      }
    },[location.pathname])



  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value, 10);
    setPageSize(size);
    setCurrentPage(1);
  };
   const fetchData = async (
      workflowId,
      currentPage,
      pageSize,
      priority,
      active,
      areaCode,
      accountNo,
      selectedUserId,
      selectedSubactivity,
      fromDate,
      toDate
    ) => {
      if (!workflowId) {
        setTaskData([]);
        setTotalValue(0);
        return;
      }
      try {
        // setLoading(true);
      //   const data = await fetchTasks({
      //     workflowId,
      //     currentPage,
      //     pageSize,
      //     priority,
      //     active,
      //     areaCode,
      //     accountNo,
      //     selectedUserId,
      //     selectedSubactivity,
      //     fromDate,
      // toDate
      //   });
      //   setTaskData(data.taskList);
      //   setTotalValue(data.totalSize);
        // setLoading(false);
      } catch (error) {
        console.error("Error fetching tasks:", error);
        // setLoading(false);
      }
    };

  //  useEffect(() => {
  //     if ((selectedOrgId, workflowId)) {
  //       setCurrentPage(0);
  //       setPageSize(10);
  //       setTaskData([]);
  //       // setActive('Active')
  //       fetchData(selectedOrgId, workflowId, currentPage, active);
  //     }
  //   }, [selectedOrgId, workflowId]);

  useEffect(() => {
    // Select the <main> tag
    const mainElement = document.querySelector('main');
  
    // Add the 'overflow-hidden' class
    mainElement.classList.add('overflow-hidden');

      // Select the <div> inside <main>
    const innerDiv = mainElement.querySelector('div');
     // Remove padding-right from the <div>
  innerDiv.classList.add("pr-0");
  
    // Cleanup function to remove the class when the component unmounts
    return () => {
      mainElement.classList.remove('overflow-hidden');
      innerDiv.classList.remove("pr-0");// Resets to the original value
    };
  }, []);

  return (
    <div className="w-full relative ">
      {/* <h4 className={`mt-3 text-sm uppercase font-semibold text-gray-800 ${
            theme === "dark"
              ? "dark-mode  "
              : theme === "high-contrast"
              ? "high-contrast  "
              : ""
          }`}>
        {translations[langMode].listvbiew}
      </h4> */}
      <div
        className={`px-[17px] py-4 w-full bg-[#EBECEF] ${
          theme === "dark"
            ? "dark-mode  "
            : theme === "high-contrast"
            ? "high-contrast  "
            : ""
        }`}  >
        <TaskListToolbar
          openTab={openTab}
          setOpenTab={setOpenTab}
          isChecked={isChecked}
          selectedtask={selectedtask}
          setIsChecked={setIsChecked}
          onFilterChange={handleFilterChange}
          setWorkflowName={setTaskData}
          setselectedtask={setselectedtask}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
         finishedStatus={finishedStatus}
        />
        <div className="py-2">
        {/* <div
        className={`px-2  bg-white rounded-[10px] py-[16px] px-[15px] ${theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
              ? "high-contrast"
              : ""
          }`}
      >
         <div className="pb-2 flex justify-between items-center">
         <div className="text-sm text-gray-400 flex items-center gap-2">
            <label htmlFor="pageSize">Show:</label>
            <select
              id="countries_disabled"
              className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-20 p-2.5  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${theme === "dark"
                  ? "dark-mode"
                  : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                }`}
              value={pageSize}
              onChange={handlePageSizeChange}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div> */}
          <TaskListView
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            selectedtask={selectedtask}
            setselectedtask={setselectedtask}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            setTotalPageSize={setTotalPageSize}
            totalPageSize={totalPageSize}
            setFinishedStatus={setFinishedStatus}
          />
         {/* </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TaskManageMain;
